export default defineNuxtRouteMiddleware((to) => {
  // 滚顶改到 plugins/scroll-top.client.js 的 afterEach，
  // 避免详情页 setup 尚未完成时把仍挂着的列表页滚到顶部（闪学习中心目录）

  if (to.path !== '/') {
    return
  }

  let currentDomain = ''
  if (process.server) {
    const headers = useRequestHeaders(['host'])
    currentDomain = headers.host || ''
  } else {
    currentDomain = window.location.host
  }
  const route = useRoute()
  const art = route.query.head
  const art1 = route.query.heads
  if(currentDomain == 'cjdxyx.ykumda.com'&&!isNaN(art)){
    return navigateTo('/index')
  }else if(currentDomain == 'cjdxyx.ykumda.com'){
    return navigateTo('/cj_home')
  }
  // if (currentDomain == 'cjdxyx.ykumda.com') {
  // // if (currentDomain == '192.168.10.8:3002') {
  //   return navigateTo('/index_hnkj')
  // }

  if(currentDomain == 'aufe.ykumda.com'&& !isNaN(art1)) {
    return navigateTo('/index')
  }else if(currentDomain == 'aufe.ykumda.com'){
    return navigateTo('/index_ahcj')
  }else if(currentDomain == 'gateway.ykyycq.com'){
    return navigateTo('/index_home')
  }
})
